import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
/* import SuccessHandler from '../SuccessHandler' */

/* private FollowUp Types */
import {
  Settings,
  _FollowUp
} from '../namespace-helper'

// selected item template

export default {
  namespaced: true,
  state: {
    followUps: []
  },
  mutations: {
    [_FollowUp.mutations.setFollowUps] (state, payload) {
      state.followUps = payload
    }
  },
  actions: {
    [_FollowUp.actions.loadFollowUps] (context, payload) {
      console.log('loadFollowUps: ' + JSON.stringify(payload))
      console.log('loadFollowUps: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/followUp?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=' +
                'internal_number:like;' +
                'product.reference:like;' +
                'purchaseOrder.customer_purchase_order_number:like;' +
                'purchaseOrder.purchase_orders_number:like;' +
                'purchaseOrder.account.firstname:like;' +
                'procurementPosition.suppliersOrdersPosition.suppliersOrder.purchase_orders_number:like;' +
                'procurementPosition.suppliersOrdersPosition.suppliersOrder.suppliers_orders_confirmation_number:like;' +
                'procurementPosition.purchaseOrdersPosition.invoicePosition.invoice.invoice_number:like;' +
      /*           'procurementPosition.suppliersOrdersPosition.suppliersOrder.suppliersOrdersStatus.name:like' + */
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending +
                '&customersId=' + payload.customers_id +
                '&suppliersId=' + payload.suppliers_id +
                (payload.selectedFrom ? '&selectedFrom=' + payload.selectedFrom : '') +
                (payload.selectedTo ? '&selectedTo=' + payload.selectedTo : '') +
                (payload.showAll ? '&showAll=' + payload.showAll : '') +
                (payload.filterDates ? '&filterDates=' + JSON.stringify(payload.filterDates) : '') +
                (payload.selectedSupplierOrderPositionStatuses ? '&selectedSupplierOrderPositionStatuses=' + JSON.stringify(payload.selectedSupplierOrderPositionStatuses) : '')

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_FollowUp.mutations.setFollowUps, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_FollowUp.actions.resetState] ({ commit }, payload) {
      commit(_FollowUp.mutations.setFollowUps, [])
    }
  },
  getters: {
    [_FollowUp.getters.followUps] (state) {
      return state.followUps
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/FollowUp/followUp.js